export enum AppRoute {
    Impersonate
}
